import React, { useEffect, useMemo } from 'react'

import { useDelayTimer, useInstData } from 'tyan/public/hooks'

const targets = {}
// window.targets = targets

const resizeObserver = new ResizeObserver(entries => {
	for (let entry of entries) {
		let { target, target: { targetid }, contentBoxSize, contentRect } = entry
		const targetValues = targets[targetid]
		if (!targetValues) continue
		const { onResize, doDelay, width: oldWidth, height: oldHeight } = targetValues
		let width, height
		contentBoxSize
			? (contentBoxSize = contentBoxSize[0] || contentBoxSize, width = contentBoxSize.inlineSize, height = contentBoxSize.blockSize)
			: (width = contentRect.width, height = contentRect.height)
		doDelay(() => {
			targetValues.width = width
			targetValues.height = height
			onResize(target, width, height, oldWidth, oldHeight)
		})
		// if (entry.contentBoxSize) {
		// 	// Checking for chrome as using a non-standard array
		// 	if (entry.contentBoxSize[0]) {
		// 		h1Elem.style.fontSize = Math.max(1.5, entry.contentBoxSize[0].inlineSize / 200) + 'rem';
		// 		pElem.style.fontSize = Math.max(1, entry.contentBoxSize[0].inlineSize / 600) + 'rem';
		// 	} else {
		// 		h1Elem.style.fontSize = Math.max(1.5, entry.contentBoxSize.inlineSize / 200) + 'rem';
		// 		pElem.style.fontSize = Math.max(1, entry.contentBoxSize.inlineSize / 600) + 'rem';
		// 	}
		// } else {
		// 	h1Elem.style.fontSize = Math.max(1.5, entry.contentRect.width / 200) + 'rem';
		// 	pElem.style.fontSize = Math.max(1, entry.contentRect.width / 600) + 'rem';
		// }
	}
})

let clearTimer = null
const addTarget = target => {
	const doClear = () => {
		clearTimer = null
		Object.values(targets).forEach(({ targetid, div, stopDelay }) =>
			!document.getElementById(targetid) && (stopDelay(), resizeObserver.unobserve(div), delete targets[targetid])
		)
		Object.keys(targets).length && tryClear()
	}

	const tryClear = () => {
		if (clearTimer) return
		clearTimer = setTimeout(doClear, 1000)
	}

	const { targetid, div } = target
	div.targetid = targetid
	targets[targetid] = target
	resizeObserver.observe(div)

	tryClear()
}

const Container = ({ children, onResize, id, ...props }) => {
	const { me } = useInstData()
	const targetid = useMemo(() => id || Tyan.getUuid(), [])
	const { doDelay, stopDelay } = useDelayTimer(50)

	useEffect(() => {
		onResize && addTarget({ targetid, div: me.div, onResize, width: 0, height: 0, doDelay, stopDelay })
	}, [])

	return <div id={targetid} ref={ref => ref && (me.div = ref)} {...props}>{children}</div>
}

export default Container